import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "../../css/JobForm.module.css";

const JobForm = () => {
  const [title, setTitle] = useState("");
  const [company, setCompany] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState(""); // New field for job description
  const [requirements, setRequirements] = useState("");
  const [salary, setSalary] = useState(""); // New field for salary
  const [jobType, setJobType] = useState("");
  const navigate = useNavigate();

  const handlePostJob = async () => {
    try {
      const newJob = {
        title,
        company,
        location,
        description,
        requirements: requirements.split(",").map((req) => req.trim()),
        salary,
        jobType,
      };
  
      await axios.post("https://techservicemarket-backend.onrender.com/api/universitypartner/jobs", newJob, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Authorization header
        },
      });
  
      alert("Job posted successfully");
      navigate("/university/dashboard");
    } catch (error) {
      console.error("Error posting job:", error.response?.data || error.message);
    }
  };

  return (
    <div className={styles.jobFormContainer}>
      <button className={styles.backButton} onClick={() => navigate("/university/dashboard")}>
        ← Back to Dashboard
      </button>
      <h2>Post a New Job</h2>
      <input
        type="text"
        placeholder="Job Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="text"
        placeholder="Company Name"
        value={company}
        onChange={(e) => setCompany(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="text"
        placeholder="Location"
        value={location}
        onChange={(e) => setLocation(e.target.value)}
        className={styles.inputField}
      />
      <textarea
        placeholder="Job Description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        className={styles.textareaField} 
      />
      <input
        type="text"
        placeholder="Requirements (comma-separated)"
        value={requirements}
        onChange={(e) => setRequirements(e.target.value)}
        className={styles.inputField}
      />
      <input
        type="text"
        placeholder="Salary (optional)"
        value={salary}
        onChange={(e) => setSalary(e.target.value)}
        className={styles.inputField}
      />
      <select
        value={jobType}
        onChange={(e) => setJobType(e.target.value)}
        className={styles.selectInput}
      >
        <option value="">Select Job Type</option>
        <option value="Full-time">Full-time</option>
        <option value="Part-time">Part-time</option>
        <option value="Contract">Contract</option>
        <option value="Internship">Internship</option>
      </select>
      <button onClick={handlePostJob} className={styles.postButton}>
        Post Job
      </button>
    </div>
  );
};

export default JobForm;
